import React, { useContext, useState } from "react";
import { withRouter } from "../utils/withRouter";
import { UserContext } from "../UserContext";
import api from "../api/index";
import { Link } from "react-router-dom";
import fulllogo from "../assets/images/spare_logo_full.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import "./styles/Login.css";
import { motion, AnimatePresence } from "framer-motion";

function Login({ navigate }) {
  const { setUser } = useContext(UserContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLogged, setIsLogged] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    // WHITE ELEPHANT
    fetch(`${api.main}api/auth/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email,
        password,
      }),
    })
      .then((res) => {
        if (!res.ok) throw new Error("Invalid email or password");
        return res.json();
      })
      .then((data) => {
        if (data.user) {
          const user = data.user;
          setUser(user);
          setIsLogged(true);

            const hasPaymentMethod = user?.payment_method === true || !!user?.sagent_payment_method_id;


            setTimeout(() => {
                navigate(hasPaymentMethod ? "/dashboard" : "/payouts");
          }, 500);
        } else {
          setError("Something went wrong. Please try again later.");
        }
      })
      .catch((err) => setError(err.message));
  };

  const heroVariants = {
    enter: { x: 0, opacity: 1 },
    exit: {
      x: "-100vw",
      opacity: 0,
      transition: { duration: 2, ease: [0.22, 1, 0.36, 1] },
    },
  };

  const cardVariants = {
    enter: { x: 0, opacity: 1 },
    exit: {
      x: "100vw",
      opacity: 0,
      transition: { duration: 3, ease: [0.22, 1, 0.36, 1] },
    },
  };

  return (
    <AnimatePresence>
    <div className={`login-page${isLogged ? " login-page--exiting" : ""}`}>
      <motion.div 
        className="login-hero" 
        variants={heroVariants}
        initial="enter"
        animate={isLogged ? "exit" : "enter"}
      >
        <div className="login-hero-content">
          <img alt="Spare" src={fulllogo} className="login-hero-logo" />
          <h1>Spare ISO Portal</h1>
          <p>
            Manage licenses, update locations, and monitor transfers in one modern workspace
            designed for ISO teams.
          </p>
          <ul>
            <li>Real-time dashboard insights</li>
            <li>License billing with proration previews</li>
            <li>CSV imports, manual forms, and bulk transfers</li>
          </ul>
        </div>
      </motion.div>

      <motion.div 
        className="login-card"
        variants={cardVariants}
        initial="enter"
        animate={isLogged ? "exit" : "enter"}
      >
        <h2>Sign in to continue</h2>
        <form onSubmit={handleSubmit} className="login-form">
          <label>Email</label>
          <input
            type="email"
            placeholder="you@company.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <label>Password</label>
          <div className="password-wrapper">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === " ") e.preventDefault();
              }}
              className="password-input"
              required
            />
            <FontAwesomeIcon
              icon={showPassword ? faEyeSlash : faEye}
              className="toggle-visibility"
              onClick={() => setShowPassword(!showPassword)}
            />
          </div>

          {error && <p className="error-text">{error}</p>}

          <button className="btn btn-primary" type="submit">
            Log In
          </button>

          <div className="login-links">
            <Link to="/forgot-password">Forgot Password?</Link>
          </div>
        </form>
      </motion.div>
    </div>
    </AnimatePresence>
  );
}

export default withRouter(Login);
